import React from 'react';
import { theme } from '@ui/theme';
import PropTypes from 'prop-types';
import {
  CurvedBadge,
  StraightBadge,
  StyledHeroBadge,
  PrimaryText,
  SecondaryText,
  SvgLayer,
  CenterContent,
  CurvedText,
} from './styles.js';

export const HeroBadge = ({
  index,
  badgeStyle = 'straight',
  primaryText,
  subText,
  boldSubText = false,
  curvedTextTop,
  curvedTextBottom,
  fontColor = 'text.lightest',
}) => {
  return (
    <StyledHeroBadge $fontColor={fontColor}>
      {badgeStyle === 'straight' ? (
        <StraightBadge $fontColor={fontColor}>
          <PrimaryText>{primaryText}</PrimaryText>
          {subText && (
            <SecondaryText $bold={boldSubText}>{subText}</SecondaryText>
          )}
        </StraightBadge>
      ) : (
        <CurvedBadge>
          <SvgLayer viewBox="0 0 95 95">
            <defs>
              <path
                id={`topArcPath-${index}`}
                d="M 10.5,47.5 A 37,37 0 0,1 84.5,47.5"
                fill="transparent"
              />
              <path
                id={`bottomArcPath-${index}`}
                d="M 0, 47.5 A 37, 37 0 0, 0 95 47.5"
                fill="transparent"
              />
            </defs>

            <CurvedText>
              <textPath
                href={`#topArcPath-${index}`}
                startOffset="50%"
                textAnchor="middle"
                fill={theme.colors.get(fontColor)}
              >
                {curvedTextTop}
              </textPath>
            </CurvedText>

            <CurvedText>
              <textPath
                href={`#bottomArcPath-${index}`}
                startOffset="50%"
                textAnchor="middle"
                fill={theme.colors.get(fontColor)}
              >
                {curvedTextBottom}
              </textPath>
            </CurvedText>
          </SvgLayer>
          <CenterContent>
            <PrimaryText>{primaryText}</PrimaryText>
            {subText && (
              <SecondaryText $bold={boldSubText}>{subText}</SecondaryText>
            )}
          </CenterContent>
        </CurvedBadge>
      )}
    </StyledHeroBadge>
  );
};
HeroBadge.displayName = 'HeroBadge';

HeroBadge.propTypes = {
  index: PropTypes.number,
  badgeStyle: PropTypes.oneOf(['straight', 'curved']),
  primaryText: PropTypes.string.isRequired,
  subText: PropTypes.string,
  boldSubText: PropTypes.bool,
  curvedTextTop: PropTypes.string,
  curvedTextBottom: PropTypes.string,
  fontColor: PropTypes.string,
};
